import React, { useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { useLessons } from '../hooks/useLessons';
import PostsListing from './PostsListing';
import TrainingPost from './TrainingPost';

const TrainingApp = () => {
  const { lessons, loading, error, lessonNavigation, getLessonBySlug } = useLessons();
  const [currentView, setCurrentView] = useState('listing');
  const [selectedLessonSlug, setSelectedLessonSlug] = useState(null);

  const handleLessonSelect = (slug) => {
    setSelectedLessonSlug(slug);
    setCurrentView('lesson');
  };

  const handleBackToListing = () => {
    setCurrentView('listing');
    setSelectedLessonSlug(null);
  };

  const handleNavigateToLesson = (slug) => {
    setSelectedLessonSlug(slug);
  };

  if (loading) {
    return (
      <div className="training-app loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading training content...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="training-app error">
        <div className="error-message">
          <h2>Error Loading Content</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  const currentLesson = selectedLessonSlug ? getLessonBySlug(selectedLessonSlug) : null;
  const navigation = selectedLessonSlug ? lessonNavigation[selectedLessonSlug] : null;

  return (
    <div className="training-app">
      <nav className="app-nav">
        {currentView === 'lesson' && (
          <button 
            className="back-button"
            onClick={handleBackToListing}
          >
            ← Back to Lessons
          </button>
        )}
      </nav>

      <main className="app-main">
        {currentView === 'listing' ? (
          <PostsListing 
            lessons={lessons}
            onLessonSelect={handleLessonSelect}
          />
        ) : currentLesson ? (
          <TrainingPost
            lesson={currentLesson}
            nextLesson={navigation?.next}
            previousLesson={navigation?.previous}
            onNavigate={handleNavigateToLesson}
          />
        ) : (
          <div className="lesson-not-found">
            <h2>Lesson Not Found</h2>
            <button onClick={handleBackToListing}>
              Back to Lessons
            </button>
          </div>
        )}
      </main>
      <Analytics />
    </div>
  );
};

export default TrainingApp;